import React from "react"


import {
  
  containerBottom
} from '../components/layout.module.css'

export default function Bottom() {
  return (
       
      <div className={containerBottom}>
            
	      Software Developer - Per Olsen - Denmark   

      </div>
   
  );
}


